const LargeGridIcon = () => {
  return (
    <svg
      height="22"
      width="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <>
        <rect x="0.5" y="0.5" width="21" height="21" fill="white" />
        <rect x="4.5" y="4.5" width="6" height="6" fill="black" />
        <rect x="4.5" y="11.5" width="6" height="6" fill="black" />
        <rect x="11.5" y="4.5" width="6" height="6" fill="black" />
        <rect x="11.5" y="11.5" width="6" height="6" fill="black" />
        <rect x="0.5" y="0.5" width="21" height="21" stroke="#F2F2F2" />
      </>
    </svg>
  );
};

export default LargeGridIcon;
